import { Alert, Button } from 'antd';
import { buildCancellationAlertMessage } from './cancellationAlerts';
import type { WaveAlert } from 'types/wave/detail';

type WaveCancellationAlertsBannerProps = {
  alerts: WaveAlert[];
  count: number;
  onReview: () => void;
};

export function WaveCancellationAlertsBanner({
  alerts,
  count,
  onReview,
}: WaveCancellationAlertsBannerProps) {
  if (count <= 0) {
    return null;
  }

  const { message, description } = buildCancellationAlertMessage(alerts, count);

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 8, cursor: 'pointer' }}
      title={message}
      description={description}
      onClick={onReview}
      action={
        <Button
          type="primary"
          danger
          onClick={event => {
            event.stopPropagation();
            onReview();
          }}
        >
          Review & Cancel
        </Button>
      }
    />
  );
}
